import Vue from 'vue'
import VueRouter from 'vue-router'
import VueProgressBar from 'vue-progressbar'
import { Form, HasError, AlertError } from 'vform'
import swal from 'sweetalert2'
import AOS from 'aos'
import 'aos/dist/aos.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VeeValidate from 'vee-validate';
import Print from 'vue-print-nb'

Vue.use(VueAxios, axios)
Vue.use(VeeValidate)
Vue.use(Print)

import './css/styles.scss'

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
  require('admin-lte');
  require('datatables.net-dt')
} catch (e) { }

Vue.use(VueRouter)

Vue.use(VueProgressBar, {
  color: 'rgb(255, 103, 0)',
  failedColor: 'red',
  thickness: '2px'
})

Vue.use(VueSession)

window.Form = Form;
Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

window.swal = swal;
const toast = swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});
window.toast = toast;
window.Fire = new Vue();

let routes = [
  { path: '/', meta: { title: 'บ้านกล่อง: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/HomePage.vue').default },
  { path: '/about', meta: { title: 'เกี่ยวกับเรา: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/AboutPage.vue').default },
  { path: '/products', meta: { title: 'สินค้าของเรา : ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/ProductPage.vue').default },
  { path: '/article', meta: { title: 'รวมบทความ: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/ArticlePage.vue').default },
  { path: '/articleDetail/:id', meta: { title: 'รวมบทความ: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/AritcleDetail.vue').default },
  { path: '/contact', meta: { title: 'ติดต่อเรา: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/ContactPage.vue').default },
  { path: '/check-out-product', meta: { title: 'CkeckOut สินค้า: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/CheckOutProduct.vue').default },
  { path: '/register', meta: { title: 'ลงทะเบียน สมัครสมาชิก: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/RegisterPage.vue').default },
  { path: '/how-to-order', meta: { title: 'วิธีสั่งซื้อสินค้า: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./frontEnd/HowToOrder.vue').default },
  { path: '/payment', meta: { title: 'แจ้งฝากเงิน: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร'}, component: require('./frontEnd/PaymentPage.vue').default },
  { path: '/pageLogin', meta: { title: 'Login Page : BannKlong' }, component: require('./backEnd/LoginPage.vue').default }, //Back end.
  { path: '/pageHome', meta: { title: 'Home Page : BannKlong' }, component: require('./backEnd/HomePage.vue').default },
  { path: '/typeProduct', meta: { title: 'Type Product : BannKlong' }, component: require('./backEnd/TypeProduct.vue').default },
  { path: '/administrator', meta: { title: 'Administrator : BannKlong' }, component: require('./backEnd/Administrator.vue').default },
  { path: '/pageProducts', meta: { title: 'Product : BannKlong' }, component: require('./backEnd/ProductPage.vue').default },
  { path: '/banners', meta: { title: 'Banner : BannKlong' }, component: require('./backEnd/BannerSlide.vue').default },
  { path: '/pageArticle', meta: { title: 'Article : BannKlong' }, component: require('./backEnd/Article.vue').default },
  { path: '/pageContact', meta: { title: 'Contact : BannKlong' }, component: require('./backEnd/Contact.vue').default },
  { path: '/pageOrders', meta: { title: 'Orders : Bannklong' }, component: require('./backEnd/Orders.vue').default},
  { path: '/pagePayment', meta: { title: 'Payments: Bannklong'}, component: require('./backEnd/Payments.vue').default},
  { path: '/pageDelivery', meta: {title: 'Delivery: Bannklong'}, component: require('./backEnd/Delivery.vue').default},
  { path: '/pageCustomers', meta: {title: 'Customers: Bannklong'}, component: require('./backEnd/Customers.vue').default},
  { path: '/pageReportOrder', meta: {title: 'Report Orders: Bannklong'}, component: require('./backEnd/ReportOrders.vue').default},
  { path: '/pageReportBestSeller', meta: {title: 'Report Best Sellers'}, component: require('./backEnd/ReportBestSeller.vue').default},
  { path: '*', meta: { title: 'ติดต่อเรา: ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร' }, component: require('./404.vue').default },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

router.beforeEach((to, from, next) => { //title name web page
  document.title = to.meta.title
  next()
});
let numeral = require("numeral");
Vue.filter("numberFormat", function (value) {
  return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});

new Vue({
  el: '#app',
  router,
  data() {
    return {
      keyid: this.$session.get('keyid'),
      keyserial: this.$session.get('keyserial'),
      keytoken: this.$session.get('keytoken'),
      modal: false,
      totalCart: 0,
      totalPrice: 0,
      carts: [],
      products: {},
      form: new Form({
          product_id:'',
          product_name:'',
          crate:'',
          crate_unit:'',
          pack:'',
          pack_unit:'',
          material:'',
          id_type:'',
          detail_more:'',
          size:'',
          status:'',
          product_image:'',
          amount:1,
          product_unit:'ลัง',
      }),
      cartAdd:{
          product_id:'',
          product_name:'',
          crate:'',
          crate_unit:'',
          pack:'',
          pack_unit:'',
          product_image:'',
          amount:'',
          product_unit:'ลัง',
      },
      form_login_cus: new Form({
        email:'',
        password:''
      }),
      keyid_cus: this.$session.get('keyid_cus'),
      keyusername_cus: this.$session.get('keyusername_cus'),
      keyserial_cus: this.$session.get('keyserial_cus'),
      keytoken_cus: this.$session.get('keytoken_cus'),
      checkLoginCustomer: this.$session.get('checkLoginCustomer'),
      notifications:{},
      notifiAmount:0
    }
  },
  methods: {
    logoutCustomer(){
      this.$session.remove('keyid_cus')
      this.$session.remove('keyusername_cus')
      this.$session.remove('keyserial_cus')
      this.$session.remove('keytoken_cus')
      this.$session.remove('checkLoginCustomer')
      toast.fire({
        type: 'success',
        title:'ออกจากระบบเรียบร้อยแล้ว'
      })
      window.location.href = ''
    },
    loginCustomer(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.form_login_cus.post('http://pgm01.toonjob.com/2019/BannKlong/project/loginCus')
          .then((res)=>{
            let data = parseInt(res.data.loginCustomer)
            if(data === 1){
              this.$session.set('keyid_cus', res.data.keyid)
              this.$session.set('keyusername_cus', res.data.keyusername)
              this.$session.set('keyserial_cus', res.data.keyserial)
              this.$session.set('keytoken_cus', res.data.keytoken)
              this.$session.set('checkLoginCustomer', true)
              toast.fire({
                type: res.data.type,
                title:res.data.message
              })
              window.location.href = ''
            }else{
              toast.fire({
                type:res.data.type,
                title:res.data.message
              })
              return false
            }
          })
        }
      })
    },
    removeCart(id) {
      this.carts.splice(id, 1)
      this.storeCart()
    },
    storeCart() {
      let parsed = JSON.stringify(this.$root.carts)
      localStorage.setItem('carts', parsed)
      this.viewCart()
    },
    addCart(pro, num) {
      this.cartAdd.product_id = pro.product_id
      this.cartAdd.product_name = pro.product_name
      this.cartAdd.crate = pro.crate
      this.cartAdd.crate_unit = pro.crate_unit
      this.cartAdd.pack = pro.pack
      this.cartAdd.pack_unit = pro.pack_unit
      this.cartAdd.product_image = pro.product_image
      this.cartAdd.amount = this.form.amount
      this.cartAdd.product_unit = (num == 1) ? pro.product_unit : 'ลัง'
      this.$root.carts.push(this.cartAdd)
      this.cartAdd = {}
      this.$root.storeCart()
      swal.fire({
        type: 'success',
        title: 'เพิ่มสินค้าลงตะกร้าเสร็จเรียบร้อย',
        showConfirmButton: false,
        timer: 1500
      })
      this.modal = false
    },
    viewCart() {
      if (localStorage.getItem('carts')) {
        this.carts = JSON.parse(localStorage.getItem('carts'))
        this.totalCart = this.carts.length
        this.totalPrice = this.carts.reduce((total, item) => {
          return total + ((item.product_unit == 'ลัง') ? ((item.crate_unit * item.crate) * item.amount) : ((item.pack_unit * item.pack) * item.amount));
        }, 0);
      }
    },
    listProduct() {
      this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/showProduct')
        .then((response) => {
          this.products = response.data
        })
    },
    checkAfterLogin() {
      if (this.keyid && this.keyserial && this.keytoken) {
        window.location.href = '/pageHome'
      }
    },
    actionLogout() {
      this.$session.remove('keyid')
      this.$session.remove('keyserial')
      this.$session.remove('keytoken')
      this.$session.remove('keyusername')
      window.location.href = '/pageLogin'
    }
  },
  created() {
    this.listProduct()
    this.viewCart()
    AOS.init()
  },
})



// WEBPACK FOOTER //
// ./src/main.js